import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref } from "vue"

const _hoisted_1 = { class: "virtual-museum" }
const _hoisted_2 = { class: "yycj" }
const _hoisted_3 = { class: "yycj-content" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "xcxgn" }
const _hoisted_6 = { class: "xcxgn-content" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "content" }

import SubTitle from '@/components/SubTitle.vue';
import ExampleIntroduction from '@/components/common/ExampleIntroduction.vue';
import StepProcess from '@/components/common/StepProcess.vue';
import { exampleDatas } from '@/config/index';
import store from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'VirtualMuseum',
  setup(__props) {

const yycjData = [
  {
    title: '博物馆',
    url: require('@/assets/images/ar-images/bwg.png')
  },
  {
    title: '艺术馆',
    url: require('@/assets/images/ar-images/ysg.png')
  },
  {
    title: '科技馆',
    url: require('@/assets/images/ar-images/kjg.png')
  },
  {
    title: '历史馆',
    url: require('@/assets/images/ar-images/lsg.png')
  },
  {
    title: '校史馆',
    url: require('@/assets/images/ar-images/xsg.png')
  },
  {
    title: '成果展',
    url: require('@/assets/images/ar-images/cgz.png')
  }
]

const gntxData = [
  {
    title: '互动体验',
    content: '虚拟博物馆提供丰富的互动功能，如虚拟导览、虚拟触摸、语音解说等，让观众能够更深入地了解展品，实现沉浸式探索。',
    url: require('@/assets/images/ar-images/icon/hdty-icon.png')
  },
  {
    title: '教育资源',
    content: '虚拟博物馆是一个宝贵的教育资源，可以为学校、研究机构等提供丰富的历史、文化、艺术等方面的素材，用于课堂教学、学术研究。',
    url: require('@/assets/images/ar-images/icon/jyzy-icon.png')
  },
  {
    title: '文化交流',
    content: '虚拟博物馆，观众可以了解世界各地的历史、文化和艺术，增进对不同文化的理解和尊重，促进不同文化之间的交流和传播。',
    url: require('@/assets/images/ar-images/icon/whjl-icon.png')
  }
]

const handleEvent = () => {
  let contactUsTop: any = store.state.contactUsTop;
  contactUsTop = {
    bottom: 457 + 'rem'
  }
  store.state.contactUsTop = JSON.parse(JSON.stringify(contactUsTop))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SubTitle, { "title-text": "应用场景" }),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(yycjData, (item, index) => {
          return _createElementVNode("div", { key: index }, [
            _createElementVNode("img", {
              src: item.url
            }, null, 8, _hoisted_4),
            _createElementVNode("div", null, _toDisplayString(item.title), 1)
          ])
        }), 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(SubTitle, {
        "mode-class": "black-style",
        "title-text": "功能特性"
      }),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(gntxData, (item, index) => {
          return _createElementVNode("div", { key: index }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("img", {
                src: item.url,
                class: "l-iamge",
                alt: ""
              }, null, 8, _hoisted_8),
              _createElementVNode("div", null, _toDisplayString(item.title), 1)
            ]),
            _createElementVNode("div", _hoisted_9, _toDisplayString(item.content), 1)
          ])
        }), 64))
      ])
    ]),
    _createVNode(ExampleIntroduction, {
      exampleData: _unref(exampleDatas).xnbwg
    }, null, 8, ["exampleData"]),
    _createVNode(StepProcess, {
      "step-title": ['一站式开发流程'],
      "step-type": "step2"
    }),
    _createElementVNode("div", { class: "counselling-btn" }, [
      _createElementVNode("div", {
        class: "btn",
        onClick: handleEvent
      }, "合作咨询")
    ])
  ]))
}
}

})